const availableBuckets = [
    {
        name: 'republic-invideo',
        alias: 'd1efk3962q5p8g',
    },
    {
        name: 'invideo-images',
        alias: 'dspewdm6uepxg',
    },
    {
        name: 'invideo-uploads',
        alias: 'd3jrdn1nm7thr1',
    },
    {
        name: 'invideo-overlays',
        alias: 'd31jnkkjbfjpqx',
    },
    {
        name: 'asset-snapshot',
        alias: 'd24ab89t81mcub',
    },
    {
        name: 'invideo-uploads-image',
        alias: 'd3lpxzh90xab0r',
    },
    {
        name: 'invideo-block-assets',
        alias: 'd360zdw5tkn3j9',
    },
    {
        name: 'converted-webm-videos',
        alias: 'd1qlugglvc8yr3',
    },
    {
        name: 'invideo-uploads-videos',
        alias: 'd1kr40z4o5df3w',
    },
    {
        name: 'invideo-uploads-audio',
        alias: 'd1ahsq9yki2fk4',
    },
    {
        name: 'invideo-music',
        alias: 'd3aqxhqn7od95x',
    },
    {
        name: 'previews-480',
        alias: 'dulpz3imcxnof',
    },
    {
        name: 'webapp-static-assets',
        alias: 'd1nc6vzg2bevln',
    },
    {
        name: 'asset-snapshot-webp-test',
        alias: 'db13gshimyyed',
    },
    {
        name: 's3-invideo-demo-bucket',
        alias: 'd23p9tb8gwzw00',
    },
];
export function getCloudfrontUrl(value) {
    let newUrl = value;
    if (value && value.indexOf('s3') && value.indexOf('amazonaws.com')) {
        const urlArr = value.split('/');
        const imageBucket = urlArr[3];
        const otherPossibleBucket = urlArr[2].split('.')[0];
        const fileArr = urlArr.slice(4);
        const filename = fileArr.join('/');
        const otherPossibleFilename = urlArr.slice(3).join('/');
        availableBuckets.forEach(bucket => {
            if (imageBucket === bucket.name &&
                !checkIfSpecialCharactersPresent(filename)) {
                newUrl = 'https://' + bucket.alias + '.cloudfront.net/' + filename;
            }
            else if (otherPossibleBucket === bucket.name &&
                !checkIfSpecialCharactersPresent(filename)) {
                newUrl =
                    'https://' +
                        bucket.alias +
                        '.cloudfront.net/' +
                        otherPossibleFilename;
            }
        });
    }
    return newUrl;
}
function checkIfSpecialCharactersPresent(fileName) {
    const specialCharacters = /[+%&?$!@#,:;=^*]/gi;
    const folderList = fileName.split('/');
    for (let i = 0; i < folderList.length; i++) {
        const name = folderList[i];
        if (specialCharacters.test(name)) {
            return true;
        }
    }
    return false;
}
export function getUrlForPreview(skipCdn, originalPreviewUrl) {
    return skipCdn ? originalPreviewUrl : getCloudfrontUrl(originalPreviewUrl);
}
